/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteIndexRequest = {
  /**
   * The name of the index to be deleted
   */
  indexName: string;
};

/** @internal */
export const DeleteIndexRequest$inboundSchema: z.ZodType<
  DeleteIndexRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  index_name: z.string(),
}).transform((v) => {
  return remap$(v, {
    "index_name": "indexName",
  });
});

/** @internal */
export type DeleteIndexRequest$Outbound = {
  index_name: string;
};

/** @internal */
export const DeleteIndexRequest$outboundSchema: z.ZodType<
  DeleteIndexRequest$Outbound,
  z.ZodTypeDef,
  DeleteIndexRequest
> = z.object({
  indexName: z.string(),
}).transform((v) => {
  return remap$(v, {
    indexName: "index_name",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteIndexRequest$ {
  /** @deprecated use `DeleteIndexRequest$inboundSchema` instead. */
  export const inboundSchema = DeleteIndexRequest$inboundSchema;
  /** @deprecated use `DeleteIndexRequest$outboundSchema` instead. */
  export const outboundSchema = DeleteIndexRequest$outboundSchema;
  /** @deprecated use `DeleteIndexRequest$Outbound` instead. */
  export type Outbound = DeleteIndexRequest$Outbound;
}

export function deleteIndexRequestToJSON(
  deleteIndexRequest: DeleteIndexRequest,
): string {
  return JSON.stringify(
    DeleteIndexRequest$outboundSchema.parse(deleteIndexRequest),
  );
}

export function deleteIndexRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteIndexRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteIndexRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteIndexRequest' from JSON`,
  );
}
